import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { VillageTable } from "@/features/village/VillageTable";

export function VillageIndex() {
  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/subdistrict",
            label: "Sub District (Kel/Desa)",
          },
        ]}
      />
      <H2>Sub District (Kel/Desa) List</H2>
      <VillageTable />
    </>
  );
}
